import { Swiper as SliderContainer, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
// @interfaces
import { IProject } from '../@interfaces/impact.interface';
import styles from '../styles/pages/payment/Basket.module.css';
import "swiper/css";
import "swiper/css/pagination";
import {CloudinaryImage} from "@cloudinary/url-gen/assets/CloudinaryImage";
import {getCloudinaryImageFromFullUrl} from "../utils/carbonclickCloudinaryHelper";
import {Resize} from "@cloudinary/url-gen/actions";

interface BasketInformationProps {
  projects?: IProject[];
}

const BasketInformation: React.FC<BasketInformationProps> = ({ projects }) => {

  return (
    <SliderContainer
      modules={[Pagination]}
      pagination={{ clickable: true }}
      className={styles.carouselContainer}
    >
      {projects?.map((project: any, index: number) => {
        let myImage:null | CloudinaryImage = getCloudinaryImageFromFullUrl(project?.thumbnailImageUrl);
        let croppedSquareAutoFocusProjectUrl: null | string = myImage == null ? null :
            myImage.resize(Resize.fill(440, 440).gravity("auto")).toURL();

        //on the rare occasion that it's not a cloudinary url, use the original url
        if(!croppedSquareAutoFocusProjectUrl && project?.thumbnailImageUrl) croppedSquareAutoFocusProjectUrl = project?.thumbnailImageUrl;

        return (
          <SwiperSlide
            className={styles.carouselItem}
            key={index}
          >
            <div
              className={styles.carouselImg}
              style={{
                background: project?.registry?.imgUrl ? `linear-gradient(180deg, rgba(255, 255, 255, 0) 70.59%, rgba(255, 255, 255, 0.83) 87.18%), url(${croppedSquareAutoFocusProjectUrl})`
                : `url(${croppedSquareAutoFocusProjectUrl})`,
              }}
            >
              {project?.registry?.imgUrl &&
                <div style={{ width: "100%" }}>
                  <img
                    src={project?.registry?.imgUrl}
                    className={styles.registryIcon}
                    alt="CarbonClick registry icon"
                  />
                </div>
              }
            </div>

            <div>
              <p className={styles.locationDescription}>
                {project?.name} in {project?.locationDescription}
              </p>
              <p className={styles.shortDescription}>
                {project?.shortDescription}
              </p>
            </div>
          </SwiperSlide>
        );
      })}
    </SliderContainer>
  )
};

export default BasketInformation;
